let prefix = 'fas';
let iconName = 'login-asahi';
let width = 512;
let height = 512;
let ligatures = [];
let unicode = 'f0000';
let svgPathData = 'M 218.37836,54.15173 V 154.91229 H 0.5 V 357.08771 H 218.37836 V 457.84827 L 435.60243,255.67285 Z M 431.6767,67.23751 v 30.09732 h 43.1831 v 317.33034 h -43.1831 v 30.09731 H 511.5 V 67.23751 Z';

export default {
    prefix: prefix,
    iconName: iconName,
    icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
    ]
}